/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiError,
  CancelMenuOrderCheckResponse,
  CreateFuelCsvDataBody,
  CreateMenuOrderBody,
  CreateMenuOrderResponse,
  GetMenuOrderChatResponse,
  GetMenuOrderDiscountsResponse,
  GetMenuOrdersFuelDataResponse,
  GetMenuOrdersOwnResponse,
  GetMenuOrdersOwnSort,
  GetMenuOrdersResponse,
  GetMenuOrdersSort,
  MenuOrder,
  MenuOrderStatus,
  OrderCancelBody,
  OrderRefundBody,
  RefundAutoMenuOrderBody,
  SortOrder,
  SubmitMenuOrderBody,
  SubmitMenuOrderResponse,
  UpdateRedemptionUrlsBody,
} from '../models/index';
import {
    ApiErrorFromJSON,
    ApiErrorToJSON,
    CancelMenuOrderCheckResponseFromJSON,
    CancelMenuOrderCheckResponseToJSON,
    CreateFuelCsvDataBodyFromJSON,
    CreateFuelCsvDataBodyToJSON,
    CreateMenuOrderBodyFromJSON,
    CreateMenuOrderBodyToJSON,
    CreateMenuOrderResponseFromJSON,
    CreateMenuOrderResponseToJSON,
    GetMenuOrderChatResponseFromJSON,
    GetMenuOrderChatResponseToJSON,
    GetMenuOrderDiscountsResponseFromJSON,
    GetMenuOrderDiscountsResponseToJSON,
    GetMenuOrdersFuelDataResponseFromJSON,
    GetMenuOrdersFuelDataResponseToJSON,
    GetMenuOrdersOwnResponseFromJSON,
    GetMenuOrdersOwnResponseToJSON,
    GetMenuOrdersOwnSortFromJSON,
    GetMenuOrdersOwnSortToJSON,
    GetMenuOrdersResponseFromJSON,
    GetMenuOrdersResponseToJSON,
    GetMenuOrdersSortFromJSON,
    GetMenuOrdersSortToJSON,
    MenuOrderFromJSON,
    MenuOrderToJSON,
    MenuOrderStatusFromJSON,
    MenuOrderStatusToJSON,
    OrderCancelBodyFromJSON,
    OrderCancelBodyToJSON,
    OrderRefundBodyFromJSON,
    OrderRefundBodyToJSON,
    RefundAutoMenuOrderBodyFromJSON,
    RefundAutoMenuOrderBodyToJSON,
    SortOrderFromJSON,
    SortOrderToJSON,
    SubmitMenuOrderBodyFromJSON,
    SubmitMenuOrderBodyToJSON,
    SubmitMenuOrderResponseFromJSON,
    SubmitMenuOrderResponseToJSON,
    UpdateRedemptionUrlsBodyFromJSON,
    UpdateRedemptionUrlsBodyToJSON,
} from '../models/index';

export interface CreateMenuOrdersAdminGenerateFuelDataRequest {
    createFuelCsvDataBody?: CreateFuelCsvDataBody;
}

export interface CreateMenuOrdersCreateRequest {
    skipOnError?: string;
    createMenuOrderBody?: CreateMenuOrderBody;
}

export interface CreateMenuOrdersIdRefundRequest {
    id: string;
    orderRefundBody?: OrderRefundBody;
}

export interface CreateMenuOrdersIdRefundAutoRequest {
    id: string;
    refundAutoMenuOrderBody?: RefundAutoMenuOrderBody;
}

export interface CreateMenuOrdersIdSendLootshopDeliveryEmailRequest {
    id: string;
    body?: object;
}

export interface CreateMenuOrdersIdTransferPaymentRequest {
    id: string;
    body?: object;
}

export interface CreateMenuOrdersSubmitRequest {
    brandMapSlug?: string;
    submitMenuOrderBody?: SubmitMenuOrderBody;
}

export interface DeleteMenuOrdersIdRequest {
    id: string;
    orderCancelBody?: OrderCancelBody;
}

export interface GetMenuOrdersAllSearchRequest {
    orderId?: string;
    business?: string;
    discount?: string;
    customer?: string;
    recipient?: string;
    dateStart?: string;
    dateEnd?: string;
    status?: Array<MenuOrderStatus>;
    sort?: GetMenuOrdersSort;
    order?: SortOrder;
    limit?: number;
    offset?: number;
    numberOfAvailableOffsets?: number;
}

export interface GetMenuOrdersIdRequest {
    id: string;
    validateOrderItems?: string;
}

export interface GetMenuOrdersIdAdminRequest {
    id: string;
}

export interface GetMenuOrdersIdCancelRequest {
    id: string;
}

export interface GetMenuOrdersIdChatRequest {
    id: string;
}

export interface GetMenuOrdersIdDiscountsRequest {
    id: string;
}

export interface GetMenuOrdersIdVerifyRequest {
    id: string;
    brandMapSlug?: string;
}

export interface GetMenuOrdersOwnSearchRequest {
    status?: Array<MenuOrderStatus>;
    sort?: GetMenuOrdersOwnSort;
    order?: SortOrder;
    limit?: number;
    offset?: number;
    numberOfAvailableOffsets?: number;
}

export interface GetMenuOrdersValidateIdRequest {
    id: string;
}

export interface UpdateMenuOrdersIdRequest {
    id: string;
    backgroundCallback?: string;
    skipOnError?: string;
    createMenuOrderBody?: CreateMenuOrderBody;
}

export interface UpdateMenuOrdersIdCheckoutRequest {
    id: string;
    body?: object;
}

export interface UpdateMenuOrdersIdCompleteDigitalRequest {
    id: string;
    body?: object;
}

export interface UpdateMenuOrdersIdUpdateRedemptionUrlsRequest {
    id: string;
    updateRedemptionUrlsBody?: UpdateRedemptionUrlsBody;
}

/**
 * MenuOrdersApi - interface
 * 
 * @export
 * @interface MenuOrdersApiInterface
 */
export interface MenuOrdersApiInterface {
    /**
     * Used to get all fuel related data for the admin to generate csv reports.
     * @param {CreateFuelCsvDataBody} [createFuelCsvDataBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MenuOrdersApiInterface
     */
    createMenuOrdersAdminGenerateFuelDataRaw(requestParameters: CreateMenuOrdersAdminGenerateFuelDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetMenuOrdersFuelDataResponse>>;

    /**
     * Used to get all fuel related data for the admin to generate csv reports.
     */
    createMenuOrdersAdminGenerateFuelData(requestParameters: CreateMenuOrdersAdminGenerateFuelDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetMenuOrdersFuelDataResponse>;

    /**
     * Used to create new menu order
     * @param {string} [skipOnError] Whether to skip the order item if an error is detected instead of throwing the error.
     * @param {CreateMenuOrderBody} [createMenuOrderBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MenuOrdersApiInterface
     */
    createMenuOrdersCreateRaw(requestParameters: CreateMenuOrdersCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateMenuOrderResponse>>;

    /**
     * Used to create new menu order
     */
    createMenuOrdersCreate(requestParameters: CreateMenuOrdersCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateMenuOrderResponse>;

    /**
     * Used by admin to refund a menu order.
     * @param {string} id 
     * @param {OrderRefundBody} [orderRefundBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MenuOrdersApiInterface
     */
    createMenuOrdersIdRefundRaw(requestParameters: CreateMenuOrdersIdRefundRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Used by admin to refund a menu order.
     */
    createMenuOrdersIdRefund(requestParameters: CreateMenuOrdersIdRefundRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Used by admin to trigger an auto refund if the order has an error or was cancelled.
     * @param {string} id 
     * @param {RefundAutoMenuOrderBody} [refundAutoMenuOrderBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MenuOrdersApiInterface
     */
    createMenuOrdersIdRefundAutoRaw(requestParameters: CreateMenuOrdersIdRefundAutoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Used by admin to trigger an auto refund if the order has an error or was cancelled.
     */
    createMenuOrdersIdRefundAuto(requestParameters: CreateMenuOrdersIdRefundAutoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Send the LootShop delivery email with redemption links and mark order as completed.
     * @param {string} id 
     * @param {object} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MenuOrdersApiInterface
     */
    createMenuOrdersIdSendLootshopDeliveryEmailRaw(requestParameters: CreateMenuOrdersIdSendLootshopDeliveryEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Send the LootShop delivery email with redemption links and mark order as completed.
     */
    createMenuOrdersIdSendLootshopDeliveryEmail(requestParameters: CreateMenuOrdersIdSendLootshopDeliveryEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Used by admin to pay a merchant for a menu order that was paid to Devour.
     * @param {string} id 
     * @param {object} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MenuOrdersApiInterface
     */
    createMenuOrdersIdTransferPaymentRaw(requestParameters: CreateMenuOrdersIdTransferPaymentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Used by admin to pay a merchant for a menu order that was paid to Devour.
     */
    createMenuOrdersIdTransferPayment(requestParameters: CreateMenuOrdersIdTransferPaymentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Used to submit the menu order to the system
     * @param {string} [brandMapSlug] 
     * @param {SubmitMenuOrderBody} [submitMenuOrderBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MenuOrdersApiInterface
     */
    createMenuOrdersSubmitRaw(requestParameters: CreateMenuOrdersSubmitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SubmitMenuOrderResponse>>;

    /**
     * Used to submit the menu order to the system
     */
    createMenuOrdersSubmit(requestParameters: CreateMenuOrdersSubmitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SubmitMenuOrderResponse>;

    /**
     * Used to cancel menu order
     * @param {string} id 
     * @param {OrderCancelBody} [orderCancelBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MenuOrdersApiInterface
     */
    deleteMenuOrdersIdRaw(requestParameters: DeleteMenuOrdersIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MenuOrder>>;

    /**
     * Used to cancel menu order
     */
    deleteMenuOrdersId(requestParameters: DeleteMenuOrdersIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MenuOrder>;

    /**
     * Used by admins to get a list of all menu orders in the system
     * @param {string} [orderId] 
     * @param {string} [business] 
     * @param {string} [discount] Used to a list of all paid orders that used this discount. You can pass in \&quot;FUEL\&quot; to ID param.
     * @param {string} [customer] 
     * @param {string} [recipient] 
     * @param {string} [dateStart] 
     * @param {string} [dateEnd] 
     * @param {Array<MenuOrderStatus>} [status] 
     * @param {GetMenuOrdersSort} [sort] 
     * @param {SortOrder} [order] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {number} [numberOfAvailableOffsets] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MenuOrdersApiInterface
     */
    getMenuOrdersAllSearchRaw(requestParameters: GetMenuOrdersAllSearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetMenuOrdersResponse>>;

    /**
     * Used by admins to get a list of all menu orders in the system
     */
    getMenuOrdersAllSearch(requestParameters: GetMenuOrdersAllSearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetMenuOrdersResponse>;

    /**
     * Used to get menu order
     * @param {string} id 
     * @param {string} [validateOrderItems] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MenuOrdersApiInterface
     */
    getMenuOrdersIdRaw(requestParameters: GetMenuOrdersIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MenuOrder>>;

    /**
     * Used to get menu order
     */
    getMenuOrdersId(requestParameters: GetMenuOrdersIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MenuOrder>;

    /**
     * Used by admin to get menu order
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MenuOrdersApiInterface
     */
    getMenuOrdersIdAdminRaw(requestParameters: GetMenuOrdersIdAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MenuOrder>>;

    /**
     * Used by admin to get menu order
     */
    getMenuOrdersIdAdmin(requestParameters: GetMenuOrdersIdAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MenuOrder>;

    /**
     * Used to do a preliminary check to see if menu order is cancellable
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MenuOrdersApiInterface
     */
    getMenuOrdersIdCancelRaw(requestParameters: GetMenuOrdersIdCancelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CancelMenuOrderCheckResponse>>;

    /**
     * Used to do a preliminary check to see if menu order is cancellable
     */
    getMenuOrdersIdCancel(requestParameters: GetMenuOrdersIdCancelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CancelMenuOrderCheckResponse>;

    /**
     * Used by customer to get the chat log between customer & support for a menu order
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MenuOrdersApiInterface
     */
    getMenuOrdersIdChatRaw(requestParameters: GetMenuOrdersIdChatRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetMenuOrderChatResponse>>;

    /**
     * Used by customer to get the chat log between customer & support for a menu order
     */
    getMenuOrdersIdChat(requestParameters: GetMenuOrdersIdChatRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetMenuOrderChatResponse>;

    /**
     * Used by customer to get a list of qualifying discounts for their menu order
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MenuOrdersApiInterface
     */
    getMenuOrdersIdDiscountsRaw(requestParameters: GetMenuOrdersIdDiscountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetMenuOrderDiscountsResponse>>;

    /**
     * Used by customer to get a list of qualifying discounts for their menu order
     */
    getMenuOrdersIdDiscounts(requestParameters: GetMenuOrdersIdDiscountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetMenuOrderDiscountsResponse>;

    /**
     * Verify that the payment has been successfully processed and redirects the customer to the order success / fail page.
     * @param {string} id 
     * @param {string} [brandMapSlug] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MenuOrdersApiInterface
     */
    getMenuOrdersIdVerifyRaw(requestParameters: GetMenuOrdersIdVerifyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Verify that the payment has been successfully processed and redirects the customer to the order success / fail page.
     */
    getMenuOrdersIdVerify(requestParameters: GetMenuOrdersIdVerifyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Used by user to get a list of all their menu orders
     * @param {Array<MenuOrderStatus>} [status] 
     * @param {GetMenuOrdersOwnSort} [sort] 
     * @param {SortOrder} [order] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {number} [numberOfAvailableOffsets] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MenuOrdersApiInterface
     */
    getMenuOrdersOwnSearchRaw(requestParameters: GetMenuOrdersOwnSearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetMenuOrdersOwnResponse>>;

    /**
     * Used by user to get a list of all their menu orders
     */
    getMenuOrdersOwnSearch(requestParameters: GetMenuOrdersOwnSearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetMenuOrdersOwnResponse>;

    /**
     * Used to validate a menu order prior to calling blockchain functions.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MenuOrdersApiInterface
     */
    getMenuOrdersValidateIdRaw(requestParameters: GetMenuOrdersValidateIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Used to validate a menu order prior to calling blockchain functions.
     */
    getMenuOrdersValidateId(requestParameters: GetMenuOrdersValidateIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Used to update menu order
     * @param {string} id 
     * @param {string} [backgroundCallback] Whether to do the menu calculation callback in the background and not awaited.
     * @param {string} [skipOnError] Whether to skip the order item if an error is detected instead of throwing the error.
     * @param {CreateMenuOrderBody} [createMenuOrderBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MenuOrdersApiInterface
     */
    updateMenuOrdersIdRaw(requestParameters: UpdateMenuOrdersIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateMenuOrderResponse>>;

    /**
     * Used to update menu order
     */
    updateMenuOrdersId(requestParameters: UpdateMenuOrdersIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateMenuOrderResponse>;

    /**
     * Used to set default values (tip amount, etc.) when customer goes to checkout.
     * @param {string} id 
     * @param {object} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MenuOrdersApiInterface
     */
    updateMenuOrdersIdCheckoutRaw(requestParameters: UpdateMenuOrdersIdCheckoutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Used to set default values (tip amount, etc.) when customer goes to checkout.
     */
    updateMenuOrdersIdCheckout(requestParameters: UpdateMenuOrdersIdCheckoutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Used to mark the digital menu order as completed.
     * @param {string} id 
     * @param {object} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MenuOrdersApiInterface
     */
    updateMenuOrdersIdCompleteDigitalRaw(requestParameters: UpdateMenuOrdersIdCompleteDigitalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Used to mark the digital menu order as completed.
     */
    updateMenuOrdersIdCompleteDigital(requestParameters: UpdateMenuOrdersIdCompleteDigitalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Update redemption URLs for digital order items (LootShop gift cards).
     * @param {string} id 
     * @param {UpdateRedemptionUrlsBody} [updateRedemptionUrlsBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MenuOrdersApiInterface
     */
    updateMenuOrdersIdUpdateRedemptionUrlsRaw(requestParameters: UpdateMenuOrdersIdUpdateRedemptionUrlsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MenuOrder>>;

    /**
     * Update redemption URLs for digital order items (LootShop gift cards).
     */
    updateMenuOrdersIdUpdateRedemptionUrls(requestParameters: UpdateMenuOrdersIdUpdateRedemptionUrlsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MenuOrder>;

}

/**
 * 
 */
export class MenuOrdersApi extends runtime.BaseAPI implements MenuOrdersApiInterface {

    /**
     * Used to get all fuel related data for the admin to generate csv reports.
     */
    async createMenuOrdersAdminGenerateFuelDataRaw(requestParameters: CreateMenuOrdersAdminGenerateFuelDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetMenuOrdersFuelDataResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/menu-orders/admin/generate-fuel-data`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateFuelCsvDataBodyToJSON(requestParameters['createFuelCsvDataBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetMenuOrdersFuelDataResponseFromJSON(jsonValue));
    }

    /**
     * Used to get all fuel related data for the admin to generate csv reports.
     */
    async createMenuOrdersAdminGenerateFuelData(requestParameters: CreateMenuOrdersAdminGenerateFuelDataRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetMenuOrdersFuelDataResponse> {
        const response = await this.createMenuOrdersAdminGenerateFuelDataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Used to create new menu order
     */
    async createMenuOrdersCreateRaw(requestParameters: CreateMenuOrdersCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateMenuOrderResponse>> {
        const queryParameters: any = {};

        if (requestParameters['skipOnError'] != null) {
            queryParameters['skipOnError'] = requestParameters['skipOnError'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/menu-orders/create`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateMenuOrderBodyToJSON(requestParameters['createMenuOrderBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateMenuOrderResponseFromJSON(jsonValue));
    }

    /**
     * Used to create new menu order
     */
    async createMenuOrdersCreate(requestParameters: CreateMenuOrdersCreateRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateMenuOrderResponse> {
        const response = await this.createMenuOrdersCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Used by admin to refund a menu order.
     */
    async createMenuOrdersIdRefundRaw(requestParameters: CreateMenuOrdersIdRefundRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createMenuOrdersIdRefund().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Discriminated", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/menu-orders/{id}/refund`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OrderRefundBodyToJSON(requestParameters['orderRefundBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Used by admin to refund a menu order.
     */
    async createMenuOrdersIdRefund(requestParameters: CreateMenuOrdersIdRefundRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createMenuOrdersIdRefundRaw(requestParameters, initOverrides);
    }

    /**
     * Used by admin to trigger an auto refund if the order has an error or was cancelled.
     */
    async createMenuOrdersIdRefundAutoRaw(requestParameters: CreateMenuOrdersIdRefundAutoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createMenuOrdersIdRefundAuto().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Discriminated", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/menu-orders/{id}/refund-auto`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RefundAutoMenuOrderBodyToJSON(requestParameters['refundAutoMenuOrderBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Used by admin to trigger an auto refund if the order has an error or was cancelled.
     */
    async createMenuOrdersIdRefundAuto(requestParameters: CreateMenuOrdersIdRefundAutoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createMenuOrdersIdRefundAutoRaw(requestParameters, initOverrides);
    }

    /**
     * Send the LootShop delivery email with redemption links and mark order as completed.
     */
    async createMenuOrdersIdSendLootshopDeliveryEmailRaw(requestParameters: CreateMenuOrdersIdSendLootshopDeliveryEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createMenuOrdersIdSendLootshopDeliveryEmail().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/menu-orders/{id}/send-lootshop-delivery-email`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Send the LootShop delivery email with redemption links and mark order as completed.
     */
    async createMenuOrdersIdSendLootshopDeliveryEmail(requestParameters: CreateMenuOrdersIdSendLootshopDeliveryEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createMenuOrdersIdSendLootshopDeliveryEmailRaw(requestParameters, initOverrides);
    }

    /**
     * Used by admin to pay a merchant for a menu order that was paid to Devour.
     */
    async createMenuOrdersIdTransferPaymentRaw(requestParameters: CreateMenuOrdersIdTransferPaymentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createMenuOrdersIdTransferPayment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/menu-orders/{id}/transfer-payment`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Used by admin to pay a merchant for a menu order that was paid to Devour.
     */
    async createMenuOrdersIdTransferPayment(requestParameters: CreateMenuOrdersIdTransferPaymentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createMenuOrdersIdTransferPaymentRaw(requestParameters, initOverrides);
    }

    /**
     * Used to submit the menu order to the system
     */
    async createMenuOrdersSubmitRaw(requestParameters: CreateMenuOrdersSubmitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SubmitMenuOrderResponse>> {
        const queryParameters: any = {};

        if (requestParameters['brandMapSlug'] != null) {
            queryParameters['brandMapSlug'] = requestParameters['brandMapSlug'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/menu-orders/submit`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SubmitMenuOrderBodyToJSON(requestParameters['submitMenuOrderBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SubmitMenuOrderResponseFromJSON(jsonValue));
    }

    /**
     * Used to submit the menu order to the system
     */
    async createMenuOrdersSubmit(requestParameters: CreateMenuOrdersSubmitRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SubmitMenuOrderResponse> {
        const response = await this.createMenuOrdersSubmitRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Used to cancel menu order
     */
    async deleteMenuOrdersIdRaw(requestParameters: DeleteMenuOrdersIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MenuOrder>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteMenuOrdersId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/menu-orders/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: OrderCancelBodyToJSON(requestParameters['orderCancelBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MenuOrderFromJSON(jsonValue));
    }

    /**
     * Used to cancel menu order
     */
    async deleteMenuOrdersId(requestParameters: DeleteMenuOrdersIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MenuOrder> {
        const response = await this.deleteMenuOrdersIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Used by admins to get a list of all menu orders in the system
     */
    async getMenuOrdersAllSearchRaw(requestParameters: GetMenuOrdersAllSearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetMenuOrdersResponse>> {
        const queryParameters: any = {};

        if (requestParameters['orderId'] != null) {
            queryParameters['orderId'] = requestParameters['orderId'];
        }

        if (requestParameters['business'] != null) {
            queryParameters['business'] = requestParameters['business'];
        }

        if (requestParameters['discount'] != null) {
            queryParameters['discount'] = requestParameters['discount'];
        }

        if (requestParameters['customer'] != null) {
            queryParameters['customer'] = requestParameters['customer'];
        }

        if (requestParameters['recipient'] != null) {
            queryParameters['recipient'] = requestParameters['recipient'];
        }

        if (requestParameters['dateStart'] != null) {
            queryParameters['dateStart'] = requestParameters['dateStart'];
        }

        if (requestParameters['dateEnd'] != null) {
            queryParameters['dateEnd'] = requestParameters['dateEnd'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = requestParameters['order'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['numberOfAvailableOffsets'] != null) {
            queryParameters['numberOfAvailableOffsets'] = requestParameters['numberOfAvailableOffsets'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Discriminated", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/menu-orders/all/search`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetMenuOrdersResponseFromJSON(jsonValue));
    }

    /**
     * Used by admins to get a list of all menu orders in the system
     */
    async getMenuOrdersAllSearch(requestParameters: GetMenuOrdersAllSearchRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetMenuOrdersResponse> {
        const response = await this.getMenuOrdersAllSearchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Used to get menu order
     */
    async getMenuOrdersIdRaw(requestParameters: GetMenuOrdersIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MenuOrder>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getMenuOrdersId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['validateOrderItems'] != null) {
            queryParameters['validateOrderItems'] = requestParameters['validateOrderItems'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/menu-orders/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MenuOrderFromJSON(jsonValue));
    }

    /**
     * Used to get menu order
     */
    async getMenuOrdersId(requestParameters: GetMenuOrdersIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MenuOrder> {
        const response = await this.getMenuOrdersIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Used by admin to get menu order
     */
    async getMenuOrdersIdAdminRaw(requestParameters: GetMenuOrdersIdAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MenuOrder>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getMenuOrdersIdAdmin().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Discriminated", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/menu-orders/{id}/admin`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MenuOrderFromJSON(jsonValue));
    }

    /**
     * Used by admin to get menu order
     */
    async getMenuOrdersIdAdmin(requestParameters: GetMenuOrdersIdAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MenuOrder> {
        const response = await this.getMenuOrdersIdAdminRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Used to do a preliminary check to see if menu order is cancellable
     */
    async getMenuOrdersIdCancelRaw(requestParameters: GetMenuOrdersIdCancelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CancelMenuOrderCheckResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getMenuOrdersIdCancel().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/menu-orders/{id}/cancel`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CancelMenuOrderCheckResponseFromJSON(jsonValue));
    }

    /**
     * Used to do a preliminary check to see if menu order is cancellable
     */
    async getMenuOrdersIdCancel(requestParameters: GetMenuOrdersIdCancelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CancelMenuOrderCheckResponse> {
        const response = await this.getMenuOrdersIdCancelRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Used by customer to get the chat log between customer & support for a menu order
     */
    async getMenuOrdersIdChatRaw(requestParameters: GetMenuOrdersIdChatRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetMenuOrderChatResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getMenuOrdersIdChat().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/menu-orders/{id}/chat`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetMenuOrderChatResponseFromJSON(jsonValue));
    }

    /**
     * Used by customer to get the chat log between customer & support for a menu order
     */
    async getMenuOrdersIdChat(requestParameters: GetMenuOrdersIdChatRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetMenuOrderChatResponse> {
        const response = await this.getMenuOrdersIdChatRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Used by customer to get a list of qualifying discounts for their menu order
     */
    async getMenuOrdersIdDiscountsRaw(requestParameters: GetMenuOrdersIdDiscountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetMenuOrderDiscountsResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getMenuOrdersIdDiscounts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/menu-orders/{id}/discounts`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetMenuOrderDiscountsResponseFromJSON(jsonValue));
    }

    /**
     * Used by customer to get a list of qualifying discounts for their menu order
     */
    async getMenuOrdersIdDiscounts(requestParameters: GetMenuOrdersIdDiscountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetMenuOrderDiscountsResponse> {
        const response = await this.getMenuOrdersIdDiscountsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Verify that the payment has been successfully processed and redirects the customer to the order success / fail page.
     */
    async getMenuOrdersIdVerifyRaw(requestParameters: GetMenuOrdersIdVerifyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getMenuOrdersIdVerify().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['brandMapSlug'] != null) {
            queryParameters['brandMapSlug'] = requestParameters['brandMapSlug'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/menu-orders/{id}/verify`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Verify that the payment has been successfully processed and redirects the customer to the order success / fail page.
     */
    async getMenuOrdersIdVerify(requestParameters: GetMenuOrdersIdVerifyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getMenuOrdersIdVerifyRaw(requestParameters, initOverrides);
    }

    /**
     * Used by user to get a list of all their menu orders
     */
    async getMenuOrdersOwnSearchRaw(requestParameters: GetMenuOrdersOwnSearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetMenuOrdersOwnResponse>> {
        const queryParameters: any = {};

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = requestParameters['order'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['numberOfAvailableOffsets'] != null) {
            queryParameters['numberOfAvailableOffsets'] = requestParameters['numberOfAvailableOffsets'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/menu-orders/own/search`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetMenuOrdersOwnResponseFromJSON(jsonValue));
    }

    /**
     * Used by user to get a list of all their menu orders
     */
    async getMenuOrdersOwnSearch(requestParameters: GetMenuOrdersOwnSearchRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetMenuOrdersOwnResponse> {
        const response = await this.getMenuOrdersOwnSearchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Used to validate a menu order prior to calling blockchain functions.
     */
    async getMenuOrdersValidateIdRaw(requestParameters: GetMenuOrdersValidateIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getMenuOrdersValidateId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/menu-orders/validate/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Used to validate a menu order prior to calling blockchain functions.
     */
    async getMenuOrdersValidateId(requestParameters: GetMenuOrdersValidateIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getMenuOrdersValidateIdRaw(requestParameters, initOverrides);
    }

    /**
     * Used to update menu order
     */
    async updateMenuOrdersIdRaw(requestParameters: UpdateMenuOrdersIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateMenuOrderResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateMenuOrdersId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['backgroundCallback'] != null) {
            queryParameters['backgroundCallback'] = requestParameters['backgroundCallback'];
        }

        if (requestParameters['skipOnError'] != null) {
            queryParameters['skipOnError'] = requestParameters['skipOnError'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/menu-orders/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateMenuOrderBodyToJSON(requestParameters['createMenuOrderBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateMenuOrderResponseFromJSON(jsonValue));
    }

    /**
     * Used to update menu order
     */
    async updateMenuOrdersId(requestParameters: UpdateMenuOrdersIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateMenuOrderResponse> {
        const response = await this.updateMenuOrdersIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Used to set default values (tip amount, etc.) when customer goes to checkout.
     */
    async updateMenuOrdersIdCheckoutRaw(requestParameters: UpdateMenuOrdersIdCheckoutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateMenuOrdersIdCheckout().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/menu-orders/{id}/checkout`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Used to set default values (tip amount, etc.) when customer goes to checkout.
     */
    async updateMenuOrdersIdCheckout(requestParameters: UpdateMenuOrdersIdCheckoutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateMenuOrdersIdCheckoutRaw(requestParameters, initOverrides);
    }

    /**
     * Used to mark the digital menu order as completed.
     */
    async updateMenuOrdersIdCompleteDigitalRaw(requestParameters: UpdateMenuOrdersIdCompleteDigitalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateMenuOrdersIdCompleteDigital().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/menu-orders/{id}/complete-digital`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Used to mark the digital menu order as completed.
     */
    async updateMenuOrdersIdCompleteDigital(requestParameters: UpdateMenuOrdersIdCompleteDigitalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateMenuOrdersIdCompleteDigitalRaw(requestParameters, initOverrides);
    }

    /**
     * Update redemption URLs for digital order items (LootShop gift cards).
     */
    async updateMenuOrdersIdUpdateRedemptionUrlsRaw(requestParameters: UpdateMenuOrdersIdUpdateRedemptionUrlsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MenuOrder>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateMenuOrdersIdUpdateRedemptionUrls().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/menu-orders/{id}/update-redemption-urls`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateRedemptionUrlsBodyToJSON(requestParameters['updateRedemptionUrlsBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MenuOrderFromJSON(jsonValue));
    }

    /**
     * Update redemption URLs for digital order items (LootShop gift cards).
     */
    async updateMenuOrdersIdUpdateRedemptionUrls(requestParameters: UpdateMenuOrdersIdUpdateRedemptionUrlsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MenuOrder> {
        const response = await this.updateMenuOrdersIdUpdateRedemptionUrlsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
